import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace ProfileAnalyticsModels {
/** 
 * StrategyEnumSchema 
 * @type { enum }
 */
export const StrategyEnumSchema = z.enum(["top", "by-category"]);
export type StrategyEnum = z.infer<typeof StrategyEnumSchema>;
export const StrategyEnum = StrategyEnumSchema.enum;

/** 
 * IndustryFitRankIndustryDtoSchema 
 * @type { object }
 * @property { string } industry  
 * @property { number } score  
 */
export const IndustryFitRankIndustryDtoSchema = z.object({ industry: z.string(), score: z.number() });
export type IndustryFitRankIndustryDto = z.infer<typeof IndustryFitRankIndustryDtoSchema>;


/** 
 * ProfileAnalyticsIndustryFitRankResponseDtoSchema 
 * @type { object }
 * @property { string } status  
 * @property { IndustryFitRankIndustryDto[] } industries  
 */
export const ProfileAnalyticsIndustryFitRankResponseDtoSchema = z.object({ status: CommonModels.StatusEnumSchema, industries: z.array(IndustryFitRankIndustryDtoSchema).nullable() });
export type ProfileAnalyticsIndustryFitRankResponseDto = z.infer<typeof ProfileAnalyticsIndustryFitRankResponseDtoSchema>;


/** 
 * GetActionPrioritiesV2StrategyParamSchema 
 * @type { string }
 */
export const GetActionPrioritiesV2StrategyParamSchema = StrategyEnumSchema.nullish();
export type GetActionPrioritiesV2StrategyParam = z.infer<typeof GetActionPrioritiesV2StrategyParamSchema>;


}
